<form
	#editForm="ngForm"
	[formReset]="editForm"
	(ngSubmit)="editForm.valid && submit()"
	*ngIf="textBlock && !loading">
	<div class="modal-header">
		<h4 class="modal-title">
			{{(textBlock.id ? 'labels.textblock-edit' : 'labels.textblock-create') | translate}}
		</h4>
		<button
			type="button"
			class="close"
			aria-label="Close"
			(click)="dismiss()">
			<span aria-hidden="true">×</span>
		</button>
	</div>
	<div
		class="modal-body"
		ngbAutofocus>
		<div
			class="row"
			*ngIf="loading">
			<div class="col text-center">
				<app-loader [material]="false"></app-loader>
			</div>
		</div>

		<div
			class="row"
			*ngIf="!loading && textBlock">
			<div class="col-sm-12">

				<div class="row">
					<!-- entity -->
					<div class="form-grpup col-md-4">
						<label>{{'labels.entity' | translate}}*</label>
						<select
							#entity="ngModel"
							class="form-control custom-select"
							[(ngModel)]="textBlock.entity"
							(ngModelChange)="autoSortField()"
							name="entity">
							<option
								*ngFor="let entity of textblockTypes"
								[value]="entity.value">
								{{'types.textblock-types.'+ entity.value | translate}}
							</option>
						</select>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && entity.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>

					<!-- sort -->
					<div class="form-group col-md-4">
						<label for="sort">{{ 'labels.sort' | translate }}*</label>
						<input
							[(ngModel)]="textBlock.sort"
							#sort="ngModel"
							name="sort"
							required
							type="number"
							class="form-control"
							id="sort"
							placeholder="{{ 'labels.sort' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && sort.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && sort.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>

					<!-- mandatory -->

					<div class="col-md-4 mt-2">
						<div class="form-group mt-4 ml-1">
							<input
								type="checkbox"
								class="form-check-input"
								name="mandatory"
								[(ngModel)]="textBlock.mandatory">
							<label class="form-check-label">{{'labels.mandatory' | translate}}</label>
						</div>
					</div>

					<!-- fname -->
					<div class="form-group col-md-12">
						<label for="name">{{ 'labels.name' | translate }}*</label>
						<textarea
							[(ngModel)]="textBlock.name"
							#name="ngModel"
							name="name"
							required
							type="text"
							class="form-control"
							id="name"
							placeholder="{{ 'labels.name' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && name.invalid}"></textarea>

						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && name.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>

				</div>

			</div>
		</div>
	</div>
	<div class="modal-footer">

		<button
			type="reset"
			class="btn btn-secondary">
			{{'labels.reset' | translate}}
		</button>
		<button
			type="button"
			class="btn btn-secondary"
			(click)="dismiss()">
			{{'labels.cancel' | translate}}
		</button>
		<button
			type="submit"
			class="btn btn-primary">
			{{'labels.save' | translate}}
		</button>
	</div>
</form>
